import { createApp } from '@app/adapters/create-app'

import RoundingConfiguration from '@app/application/accounts/rounding-configuration'
import $ from 'jquery'

onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='accounts-rounding-configuration']")
    .each(function () {
      const $this = $(this)

      createApp(RoundingConfiguration, {
        ledgerId: $this.data('ledger-id'),
        ledgerDate: $this.data('ledger-date'),
        roundingPLAccount: $this.data('pl-account'),
        roundingBSAccount: $this.data('bs-account'),
        roundingDifferencePL: $this.data('pl-rounding-diff'),
        roundingDifferenceBS: $this.data('bs-rounding-diff'),
        existingAccounts: $this.data('existing-accounts'),
      }).mount(this)
    })
})
